import React from "react";
import * as Actions from '../../state/Actions';
import { AttachFile } from "@mui/icons-material";
import CustomInput from "../custom/input/CustomInput";
import { stateChangeManager } from "../../utils/Utils";
import { ImagePreviewModal } from "./ImagePreviewModal";
import CustomTypography from "../custom/typography/CustomTypography";

import {
    Box,
    Grid,
} from "@mui/material"

export const InputFile = (props) => {
    const { onFileUpload, multiple = false, attachment, onFileRemove, fileSize = 3 } = props
    const dispatch = Actions.getDispatch(React.useContext)

    const [file, setFile] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const onClose = () => {
        setOpen(false)
    }
    const inputRef = React.useRef(null)


    const onFileChange = (e) => {
        if (e.target.files.length > 0) {
            const file = e.target.files[0]
            const extension = file.name.split(".")[file.name.split(".").length - 1]
            if (extension === "gif" || extension === "jpeg" || extension === "jpg" || extension === "jpe" || extension === "png" || extension === "bmp" || extension === "pdf" || extension === "doc" || extension === "docx" || extension === "xls" || extension === "xlsx" || extension === "csv" || extension === "xml") {
                let file_size = (file.size / 1024 / 1024)
                if (file_size > fileSize) {
                    onFileRemove()
                    setFile(null)
                    inputRef.current.value = ''
                    stateChangeManager(dispatch, Actions, true, 'error', "Maximum file size allowed is " + fileSize + "MB. Please try with different file.")
                } else {
                    if (multiple) {
                        onFileUpload(e.target.files)
                        setFile(e.target.files[0])
                    } else {
                        onFileUpload(e.target.files[0])
                        setFile(e.target.files[0])
                    }
                }

            } else {
                stateChangeManager(dispatch, Actions, true, 'error', `Incorrect file type. Please try with different file in [.gif,.jpeg,.jpg,.jpe,.png,.bmp,.pdf,.doc,.docx,.xls, .xlsx,.csv,.xml,] format.`)

            }

        } else {
            setFile(null)
            onFileUpload(null)
        }
    }

    const fileName = (file || attachment) ? file && file.name ? file.name : attachment.split("/")[attachment.split("/").length - 1] : null;
    return (
        <React.Fragment>
            <ImagePreviewModal open={open} onClose={onClose} file={file} attachment={attachment} onFileRemove={onFileRemove} fileName={fileName} />
            <Grid item xs={12} container>
                <Grid item xs={6}>
                    <CustomTypography
                        text={'Attach File'}
                        sx={{
                            mb: 1,
                            color: '#000000',
                            fontSize: '14px',
                            textAlign: 'start',
                            fontWeight: '700',
                            lineHeight: '18px',
                            fontStyle: 'normal',
                            fontFamily: "Noto Sans",
                        }}
                    />
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right', }}>
                    {(file || attachment) && <CustomTypography
                        id={props.id ? props.id + '_view' : 'attachment_action_view'}
                        dataTestId={props.dataTestId ? props.dataTestId + '_view' : 'attachment_action_view'}
                        text={'View'}
                        onClick={() => setOpen(true)}
                        sx={{
                            mb: 1,
                            pr: 1,
                            fontSize: '12px',
                            display: 'inline',
                            color: '#2464EB',
                            cursor: 'pointer',
                            display: 'inline',
                            fontWeight: '700',
                            lineHeight: '16px',
                            fontStyle: 'normal',
                            textTransform: "none",
                            fontFamily: "Noto Sans",
                            ":hover": { textDecoration: 'underline' },
                        }}
                    />

                    }
                    {(file || (attachment && typeof attachment !== "object")) && <CustomTypography
                        id={props.id ? props.id + '_remove' : 'attachment_action_remove'}
                        dataTestId={props.dataTestId ? props.dataTestId + '_remove' : 'attachment_action_remove'}
                        text={'Remove'}
                        onClick={() => {
                            onFileRemove()
                            setFile(null)
                            // inputRef.current.value = ''
                        }}
                        sx={{
                            mb: 1,
                            pl: 1,
                            fontSize: '12px',
                            display: 'inline',
                            color: '#2464EB',
                            cursor: 'pointer',
                            display: 'inline',
                            fontWeight: '700',
                            lineHeight: '16px',
                            fontStyle: 'normal',
                            textTransform: "none",
                            fontFamily: "Noto Sans",
                            ":hover": { textDecoration: 'underline' },
                        }}
                    />


                    }

                </Grid>
            </Grid>
            {(file || (attachment && typeof attachment !== "object")) ?
                <Box sx={{ height: 50, border: '1px solid #aea4a4ab', borderRadius: 1 }}>
                    <CustomTypography
                        text={<span><AttachFile sx={{ mb: -1 }} /> <span style={{ color: '#000000' }}>{fileName}</span></span>}
                        sx={{
                            ml: 1,
                            pt: 1.2,
                            color: '#7A7A7A',
                            fontSize: '12px',
                            textAlign: 'start',
                            fontWeight: '700',
                            lineHeight: '18px',
                            fontStyle: 'normal',
                            fontFamily: "Noto Sans",
                        }}
                    />
                </Box>
                :
                <CustomInput
                    id={'file_upload'}
                    dataTestId={'file_upload'}
                    size="medium"
                    type={'file'}
                    fullWidth={true}
                    inputRef={inputRef}
                    onChange={(e) => { onFileChange(e) }}
                    inputProps={{
                        accept: `
                    .gif,
                    .jpeg,
                    .jpg,
                    .jpe,
                    .png,
                    .bmp,
                    .pdf,
                    .doc,
                    .docx,
                    .xls, 
                    .xlsx,
                    .csv,
                    .xml,`, multiple: multiple, style: { color: '#000000', fontWeight: '500 !important', lineHeight: '16px', fontSize: '12px', fontStyle: 'normal', fontFamily: 'Noto Sans', }
                    }}
                />
            }
            <CustomTypography
                text={'Maximum Size: 3 MB'}
                sx={{
                    mt: 1,
                    color: '#292929',
                    fontSize: '10px',
                    textAlign: 'start',
                    fontWeight: '400',
                    lineHeight: '14px',
                    fontStyle: 'normal',
                    fontFamily: "Noto Sans",
                }}
            />

        </React.Fragment>
    )
}
